<template>

    <Modal :open="displayModal" @close="displayModal = false">
        <div class="w-full bg-white shadow-lg rounded-none md:rounded-lg p-6" @click.self="displayModal = false">

            <div class="w-full relative">
                <h2 class="font-semibold text-gray-900 text-2xl leading-tight border-b-2 border-gray-200 pb-4">View Video</h2>
                <button class="text-grey-darkest font-bold rounded absolute top-0 right-0 outline-none text-xl absolute" @click="displayModal = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="mt-4">

                <YouTubePlayer :youtube_id="data.youtube_id" />

            </div>

            <!-- footer -->
            <div class="mt-10 clearfix">
                <button v-on:click="close()" class="px-4 py-2 text-white font-semibold bg-blue-700 hover:bg-blue-800 border border-transparent rounded focus:outline-none focus:shadow-outline float-right">
                    Close
                </button>
            </div>

        </div>
        
    </Modal>

</template>

<script>
    import { EventBus } from '@/utils/events';
    import Modal from '@/components/Modal'
    import YouTubePlayer from '@/components/media/components/YouTubePlayer'

    export default {
        data() {
            return {
                displayModal: false,
                data: {},
            }
        },

        components: {
            Modal,
            YouTubePlayer
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('stringer-view-video-open-modal', this.open);
            }.bind(this));
        },

        destroyed() {
            EventBus.$off('stringer-view-video-open-modal', this.open);
        },

        methods: {

            close() {
                this.displayModal = false
            },

            open(data) {
                console.log('got data')
                this.displayModal = true
                this.data = data;
            },
        }
        
    }
</script>